export const accountMenu = {
  roles: {
    collaborator: "متعاون",
    hostMode: "وضع المضيف",
  },
  header: {
    collaboratorAccess: "الدخول كمتعاون",
  },
  panel: {
    label: "عرض اللوحة",
    apartment: "شقة",
    hotel: "فندق",
  },
  groups: {
    navigate: "التنقل",
    manage: "الإدارة",
  },
  items: {
    home: "الرئيسية",
    bookings: "الحجوزات",
    myAccount: "حسابي",
    myAccommodations: "أماكن إقامتي",
    aiReception: "استقبال الذكاء الاصطناعي",
    aiReceptionist: "موظف الاستقبال بالذكاء الاصطناعي",
    directBookings: "الحجوزات المباشرة",
    website: "الموقع الإلكتروني",
    logout: "تسجيل الخروج",
  },
  badges: {
    ai: "ذكاء اصطناعي",
    new: "جديد",
  },
  actions: {
    close: "إغلاق",
  },
};
